import ServicesPage from '@/views/ironwork/list/Index.vue'
import ServicesDetailPage from '@/views/ironwork/detail/Index.vue'

export default [
  {
    path: 'servicios-herraje',
    name: 'ironwork.list',
    component: ServicesPage
  },
  {
    path: 'servicios-herraje/:id/detalle',
    name: 'ironwork.detail',
    component: ServicesDetailPage
  }
]
